import {URL_BASE_API } from '../configs/urlConfigs';
import axios from 'axios';

export const loginUserService = (request) => {
  const LOGIN_ENDPOINT = URL_BASE_API+'login/';  
  const parameters = {
    url: LOGIN_ENDPOINT,
    method: 'POST',
    headers:{
      'Content-Type': 'application/json'
    },
    data: request.data
  };

  return axios(parameters)
    .then(response => {   
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText,
      message: error.response.data.message
    };
    return errorResp; 
  }); 
  
};


export const logoutUserService = (request) => {
  const LOGOUT_ENDPOINT = URL_BASE_API+'logout/';
  const parameters = {
    url: LOGOUT_ENDPOINT,
    method: 'POST',
    headers:{
      'Content-Type': 'application/json',
      'unid':request.data.unid
    },
    data: request.data
  };

  return axios(parameters)
    .then(response => {   
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText
    };
    return errorResp; 
  }); 
};

// export const forgotPasswordService = (request) => {
//   const FORGOT_ENDPOINT = baseurl('forgot');

//   const parameters = {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(request.email)
//   };

//   return fetch(FORGOT_ENDPOINT, parameters)
//     .then(response => {
//       return response.json();
//     })
//     .then(json => {
//       return json;
//     })
//     .catch(error => {
//       return error;
//     });
// };

export const emailVerificationService = (request) => {
  const EMAILVERIFY_ENDPOINT = URL_BASE_API+'activate-user/?uid='+request.data.userId+'&token='+request.data.userToken+'&time='+request.data.time; 

  const parameters = {
    url: EMAILVERIFY_ENDPOINT,
    method: 'GET'
  };

  return axios(parameters)
    .then(response => {        
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText
    };
    return errorResp; 
  }); 
};

export const setPasswordService = (request) => {
  const SETPASSWORD_ENDPOINT = URL_BASE_API+'user/resetpassword/'+request.data.userId; 
  let setPwdData = {
    token: request.data.userToken, 
    new_password: request.data.txtPassword
  }
  const parameters = {
    url: SETPASSWORD_ENDPOINT,
    method: 'PUT',
    data: setPwdData
  };

   return axios(parameters)
     .then(response => {     
         return response;
     }).catch(error=>{
        let errorResp = {      
          status: error.response.status,
          statusText: error.response.statusText
        };
        return errorResp; 
  }); 
}; 

export const loginClientAffiliateList = (request) => {
  const ENDPOINT = URL_BASE_API+'user/client-affiliates/'+request.data.clientId; 

  const parameters = {
    url: ENDPOINT,
    method: 'GET',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer '+request.data.userGroupToken,
        'unid':request.data.unid
    }
  };

  return axios(parameters)
    .then(response => {        
      return response;
  }).catch(error=>{
    let errorResp = {      
      affiliatesListStatus: error.response.status,
      affiliatesListStatusText: error.response.statusText
    };
    return errorResp; 
  }); 
};

export const forgotPassword = (request) => {
  const LOGIN_ENDPOINT = URL_BASE_API+'send-reset-email-link/';  
  const parameters = {
    url: LOGIN_ENDPOINT,
    method: 'POST',
    headers:{
      'Content-Type': 'application/json'
    },
    data: request.data
  };

  return axios(parameters)
    .then(response => {   
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText,
      message: error.response.data.message
    };
    return errorResp; 
  }); 
};


export const resetPasswordVerify = (request) => {
  const RESET_VERIFY_ENDPOINT = URL_BASE_API+'user/verify-reset-password-link/?uid='+request.data.userId+'&token='+request.data.userToken+'&time='+request.data.time; 

  const parameters = {
    url: RESET_VERIFY_ENDPOINT, 
    method: 'GET'
  };

  return axios(parameters)
    .then(response => {        
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText
    };
    return errorResp; 
  }); 
};


export const refreshTokenService = (request) => {
  const ENDPOINT = URL_BASE_API+'token-refresh/';  
  const parameters = {
    url: ENDPOINT,
    method: 'POST',
    headers:{
      'Content-Type': 'application/json'
    },
    data: request.data
  };

  return axios(parameters)
    .then(response => {   
      return response;
  }).catch(error=>{
    let errorResp = {      
      status: error.response.status,
      statusText: error.response.statusText,
      message: error.response.data.message
    };
    return errorResp; 
  }); 
  
};

